import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { FaBookOpen, FaPlus, FaSave, FaTimes } from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/payroll.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

//Created By Cursor
export default function MdlAddSubjectMasterList({
  open,
  session_id = "",
  onClose,
  actionClose,
}) {
  const close = onClose || actionClose;
  const [subjectName, setSubjectName] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSubjectName("");
    setError("");
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !saving && typeof close === "function") {
        close();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, close, saving]);

  //Created By Cursor
  const handleSave = async () => {
    const name = subjectName.trim();
    if (!name) {
      setError("Please enter a subject name");
      return;
    }
    setError("");
    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) {
      myToast.notify_warning("School code missing.");
      return;
    }

    if (!session_id) {
      myToast.notify_warning("Select a session first.");
      return;
    }

    setSaving(true);
    try {
      const params = new URLSearchParams();
      params.append("subject_name", name);
      params.append("school_code", schoolCode);
      //Created By Cursor — bind new subject to selected session
      params.append("session_id", session_id);
      const res = await axios.post(
        `${API_BASE()}AddNewMasterSubject.php`,
        params
      );
      if (res.data?.api_status === "OK") {
        myToast.notify_success("Subject added.");
        if (typeof close === "function") close();
      } else {
        myToast.notify_warning(
          res.data?.api_remark || "Failed to add subject."
        );
      }
    } catch (err) {
      console.error("[MdlAddSubjectMasterList]", err);
      myToast.notify_error("Failed to add subject.");
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  const modal = (
    <div
      className="sl-mdl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="sl-mdl-add-title"
    >
      <button
        type="button"
        className="sl-mdl__backdrop"
        aria-label="Close"
        disabled={saving}
        onClick={close}
      />
      <div className="sl-mdl__panel">
        <header
          className="sl-mdl__hero"
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`,
          }}
        >
          <div className="sl-mdl__hero-main">
            <div className="sl-mdl__hero-icon" aria-hidden>
              <FaPlus />
            </div>
            <div className="min-w-0">
              <p className="sl-mdl__eyebrow">Master list</p>
              <h2 id="sl-mdl-add-title" className="sl-mdl__title">
                Add subject
              </h2>
            </div>
          </div>
          <button
            type="button"
            className="sl-mdl__close"
            onClick={close}
            disabled={saving}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </header>

        <div className="sl-mdl__body">
          <label className="sl-mdl__field">
            <span>Subject name</span>
            <div className="sl-mdl__input-wrap">
              <FaBookOpen aria-hidden />
              <input
                type="text"
                value={subjectName}
                onChange={(e) => {
                  setSubjectName(e.target.value);
                  if (error) setError("");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSave();
                }}
                placeholder="e.g. Mathematics"
                autoFocus
                disabled={saving}
              />
            </div>
            {error ? <em className="sl-mdl__error">{error}</em> : null}
          </label>
        </div>

        <footer className="sl-mdl__footer">
          <button
            type="button"
            className="sl-mdl__btn sl-mdl__btn--ghost"
            disabled={saving}
            onClick={close}
          >
            Cancel
          </button>
          <button
            type="button"
            className="sl-mdl__btn sl-mdl__btn--primary"
            disabled={saving}
            onClick={handleSave}
          >
            <FaSave />
            <span>{saving ? "Saving…" : "Add subject"}</span>
          </button>
        </footer>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
